module.exports = "/_next/static/images/ddd131b2217ad93aa8a0cd6f4547aa31-purple-man@1x.jpg.webp";